/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Subscription_RequiredInputs */

const en_mobile_benefits_subscription_required = /** @type {(inputs: Mobile_Benefits_Subscription_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription required`)
};

const es_mobile_benefits_subscription_required = /** @type {(inputs: Mobile_Benefits_Subscription_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción requerida`)
};

/**
* | output |
* | --- |
* | "Subscription required" |
*
* @param {Mobile_Benefits_Subscription_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_subscription_required = /** @type {((inputs?: Mobile_Benefits_Subscription_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Subscription_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_subscription_required(inputs)
	return en_mobile_benefits_subscription_required(inputs)
});